import { Component, Input } from '@angular/core';

@Component({
  selector: 'lum-ui-alert',
  templateUrl: './ui-alert.component.html',
  styleUrls: ['./ui-alert.component.scss'],
})
export class UiAlertComponent {
  @Input()
  message :string = '';

  @Input()
  description :string = '';

  @Input()
  isHtmlCode :boolean = false;

  @Input()
  type :'success' | 'info' | 'warning' | 'error';

  @Input()
  showIcon :boolean = false;

  @Input()
  showClose :boolean = false;

  closed :boolean = false;

  onClose() :void {
    this.closed = true;
  }

  get classes() :string[] {
    const mode = `lum-alert--${this.type}`;

    return ['lum-alert', mode];
  }

  get iconAttribute() :any {
    switch (this.type) {
      case 'success':
        return {
          icon: 'check-circle',
          hex: '#23491C',
        };
      case 'info':
        return {
          icon: 'alert-information-circle',
          hex: '#55ABC5',
        };
      case 'warning':
        return {
          icon: 'alert-warning-circle',
          hex: '#D8B949',
        };
      case 'error':
        return {
          icon: 'close-circle',
          hex: '#DB3A50',
        };
      default:
        return {
          icon: 'check-circle',
          hex: '#D8B949',
        };
    }
  }
}
